import { Directive, Input, AfterViewInit } from '@angular/core';
import { ResourcesService } from '@m4u-angular/core/framework/resources.service';
import { DxTextBoxComponent, DxSelectBoxComponent, DxNumberBoxComponent, DxCheckBoxComponent,
    DxRadioGroupComponent, DxDateBoxComponent, DxTextAreaComponent, DxTagBoxComponent } from 'devextreme-angular';
import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { ValidationRule } from 'devextreme/common';
import Validator from 'devextreme/ui/validator';

export class M4UStandardDirective implements AfterViewInit {
    constructor(private c: any,
        private rule: 'async' | 'compare' | 'custom' | 'email' | 'numeric' | 'pattern' | 'range' | 'required' | 'stringLength',
        private IsColumn: boolean,
        private resourcesService: ResourcesService) { }

    private m_bInitComplete: boolean;

    _Enabled = true;
    @Input() set Enabled(value: boolean) {

        // Prevent double execution
        if (this.Enabled === value) {
            return;
        }

        this._Enabled = value;


        // Run only if changing after initialization
        if (this.m_bInitComplete) {
            this.Init();
        }
    }

    @Input() RequiredMessage: string;
    @Input() DoNotShowRequiredMsg: boolean;

    ngAfterViewInit() {
        this.Init();
        this.m_bInitComplete = true;
    }

    private Init() {
        if (this.IsColumn) {
            this.InitColumnRules();
        } else {
            this.InitNormalRules();
        }
    }

    InitNormalRules() {
        const oElementInstance = this.c.instance;
        let validatorInstance = Validator.getInstance(oElementInstance.element()) as Validator;
        if (!validatorInstance) {
            validatorInstance = new Validator(oElementInstance.element(), {});
        }

        // var overlay = validatorInstance.element().find(".dx-invalid-message.dx-overlay");
        // overlay.dxValidationMessage("instance" ).option( "position", {
        //            my: 'bottom right',
        //            at: "top right",
        // });

        const rules = validatorInstance.option('validationRules').filter(x => x.type !== this.rule);

        // Add the rule, or filter it out
        if (this._Enabled) {
            rules.push({
                type: this.rule,
                message: this.DoNotShowRequiredMsg ? '' : (this.RequiredMessage || (this.resourcesService.RC('errorRequiredMessage')))
            });
        }

        // Set
        validatorInstance.option('validationRules', rules);
    }

    InitColumnRules() {
        let rules = this.c._getOption('validationRules') as ValidationRule[];
        if (rules === undefined) {
            rules = [];
        }

        // Add the rule, or filter it out
        if (this._Enabled) {
            rules.push({ type: this.rule });
        } else {
            rules = rules.filter(x => x.type !== this.rule);
        }

        // Set
        this.c._setOption('validationRules', rules);
    }
}


@Directive({ selector: 'dx-text-box[configRequired]' })
export class M4URequiredDirectiveTextBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxTextBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dx-number-box[configRequired]' })
export class M4URequiredDirectiveNumberBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxNumberBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dx-select-box[configRequired]' })
export class M4URequiredDirectiveSelectBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxSelectBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dx-check-box[configRequired]' })
export class M4URequiredDirectiveCheckBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxCheckBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}


@Directive({ selector: 'dx-radio-group[configRequired]' })
export class M4URequiredDirectiveRadioGroup extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxRadioGroupComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}


@Directive({ selector: 'dx-date-box[configRequired]' })
export class M4URequiredDirectiveDateBox extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxDateBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dxi-column[configRequired]' })
export class M4URequiredDirectiveColumn extends M4UStandardDirective implements AfterViewInit  {
    constructor(c: DxiColumnComponent, resourcesService: ResourcesService) {
        super(c, 'required', true, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dx-text-area[configRequired]' })
export class M4URequiredDirectiveTextArea extends M4UStandardDirective implements AfterViewInit {
    constructor(c: DxTextAreaComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}

@Directive({ selector: 'dx-tag-box[configRequired]' })
export class M4URequiredDirectiveTagBox extends M4UStandardDirective implements AfterViewInit {
    constructor(c: DxTagBoxComponent, resourcesService: ResourcesService) {
        super(c, 'required', false, resourcesService);
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}
